var _defs, _path, _path2, _line, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsTemperatureFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:8px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.5,224.35V51.42A44.92,44.92,0,0,0,183.58,6.5h-1.16A44.92,44.92,0,0,0,137.5,51.42V223.18a90.51,90.51,0,1,0,91,1.17ZM182,344a44,44,0,0,1-3.5-87.86V133.5a4,4,0,0,1,8,0V256.23A44,44,0,0,1,182,344Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226,300a44,44,0,1,1-47.5-43.86V133.5a4,4,0,0,1,8,0V256.23A44,44,0,0,1,226,300Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 259.5,
    y1: 59.5,
    x2: 308.5,
    y2: 59.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 268.5,
    y1: 96.5,
    x2: 299.5,
    y2: 96.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 260,
    y1: 133.5,
    x2: 309,
    y2: 133.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 260,
    y1: 207.5,
    x2: 309,
    y2: 207.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 269,
    y1: 170.5,
    x2: 300,
    y2: 170.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsTemperatureFill);
export default __webpack_public_path__ + "static/media/Icons_Temperature Fill.afa31475442025d8de4b1b6172216d41.svg";
export { ForwardRef as ReactComponent };